import React from "react";
import { Button } from "antd";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useFeedbackDialog } from "@/context/feedbackDialog.context";

export default function FeedbackButton({ mini = false }) {
  const { openIssueId, setOpenIssueId } = useFeedbackDialog();

  return (
    <Button
      id="having_issues_button"
      type="primary"
      className={`px-2 ${mini ? "" : "pulsating-btn"}`}
      onClick={() => setOpenIssueId(openIssueId === null ? -1 : null)}
    >
      {!mini && <HelpOutlineIcon />}
      Need Help{mini && "?"}
    </Button>
  );
}
